export const DATE_FORMATS = {
  detail: 'MM/dd/yyyy hh:mm a',
};
